(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7eff786"] && !Shopify.designMode) return;
  try {
    const STORAGE_KEY = 'recently-viewed-products';
  const MAX_STORED = 24;

  function readIds() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.map((id) => parseInt(id, 10)).filter((id) => Number.isInteger(id) && id > 0);
    } catch {
      return [];
    }
  }

  function writeIds(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_STORED)));
    } catch {
      // Storage full or blocked (private mode, cookie consent) — fail silently.
    }
  }

  function trackProductView(productId) {
    const id = parseInt(String(productId), 10);
    if (!Number.isInteger(id) || id <= 0) return;

    const ids = readIds().filter((existing) => existing !== id);
    ids.unshift(id);
    writeIds(ids);
  }

  // Outermost wrapper of a product item: the carousel slide in a carousel,
  // the item itself in a grid.
  function itemRoot(item, root) {
    let node = item;
    while (
      node.parentElement &&
      node.parentElement !== root &&
      node.parentElement.querySelectorAll('[data-product-id]').length < 2
    ) {
      node = node.parentElement;
    }
    return node;
  }

  // The Search API ignores the order of the `id:` terms, so restore visit order.
  function sortByViewOrder(root, ids) {
    const items = Array.from(root.querySelectorAll('[data-product-id]'));
    if (items.length < 2) return;

    const order = new Map(ids.map((id, index) => [id, index]));
    const groups = new Map();

    for (const item of items) {
      const node = itemRoot(item, root);
      const parent = node.parentElement;
      if (!parent) continue;

      const index = order.get(parseInt(item.dataset.productId ?? '', 10)) ?? Number.MAX_SAFE_INTEGER;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push({ node, index });
    }

    for (const [parent, entries] of groups) {
      entries.sort((a, b) => a.index - b.index).forEach(({ node }) => parent.appendChild(node));
    }
  }

  class RecentlyViewedProducts extends HTMLElement {
    #abortController = new AbortController();

    connectedCallback() {
      const currentProductId = parseInt(this.dataset.currentProductId ?? '', 10) || null;
      const maxProducts = parseInt(this.dataset.maxProducts ?? '', 10) || 4;
      const designMode = this.dataset.designMode === 'true';

      // Read the history *before* recording the current product, so the product
      // the visitor is looking at right now never shows up in its own list.
      const ids = readIds()
        .filter((id) => id !== currentProductId)
        .slice(0, maxProducts);

      if (currentProductId) trackProductView(currentProductId);

      // Already rendered server-side through the Section Rendering API.
      if (this.dataset.searchPerformed === 'true') return;

      if (ids.length === 0) {
        if (!designMode) this.hidden = true;
        return;
      }

      this.#render(ids);
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    async #render(ids) {
      const query = ids.map((id) => `id:${id}`).join(' OR ');
      const url = `${this.dataset.url}&q=${encodeURIComponent(query)}`;

      try {
        const response = await fetch(url, { signal: this.#abortController.signal });
        if (!response.ok) throw new Error(`Recently viewed products: ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('recently-viewed-products');
        if (!source) throw new Error('Recently viewed products: section markup not found');

        if (!source.querySelector('[data-product-id]')) {
          this.hidden = true;
          return;
        }

        sortByViewOrder(source, ids);
        this.innerHTML = source.innerHTML;
        this.hidden = false;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        console.error(error);
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
